import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["org", "desktopNav", "mobileToggle", "userCaret", "drawer", "drawerBackdrop"]

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    this.onResize = this.onResize.bind(this)
    this.onKeydown = this.onKeydown.bind(this)

    document.addEventListener("click", this.closeOnClickOutside)
    document.addEventListener("keydown", this.onKeydown)

    if (this.hasDesktopNavTarget) {
      const row = this.desktopNavTarget.parentElement
      const rightSide = row.lastElementChild
      this.resizeObserver = new ResizeObserver(this.onResize)
      ;[row, this.desktopNavTarget, rightSide, this.hasOrgTarget && this.orgTarget]
        .filter(Boolean)
        .forEach((el) => this.resizeObserver.observe(el))
      document.fonts?.ready.then(this.onResize)
    }

    this.measureAndToggle()
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside)
    document.removeEventListener("keydown", this.onKeydown)
    this.resizeObserver?.disconnect()
    cancelAnimationFrame(this.resizeFrame)
  }

  onKeydown(event) {
    if (event.key === "Escape") this.closeDrawer()
  }

  measureAndToggle() {
    window.thqHeaderFit?.(this.element)
  }

  onResize() {
    cancelAnimationFrame(this.resizeFrame)
    this.resizeFrame = requestAnimationFrame(() => this.measureAndToggle())
  }

  // --- Dropdowns ---

  toggleDropdown(event) {
    const dropdown = event.currentTarget.closest("[data-dropdown-id]")
    if (!dropdown) return

    const dropdownId = dropdown.dataset.dropdownId
    const menu = this.element.querySelector(`[data-dropdown-menu="${dropdownId}"]`)
    if (!menu) return

    this.closeAllDropdowns(dropdownId)
    const isOpen = menu.classList.toggle("hidden")
    if (dropdownId === "user-menu" && this.hasUserCaretTarget) {
      this.userCaretTarget.classList.toggle("rotate-180", !isOpen)
    }
  }

  // --- Shared ---

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.closeAllDropdowns()
    }
  }

  closeAllDropdowns(exceptId = null) {
    this.element.querySelectorAll("[data-dropdown-menu]").forEach((menu) => {
      if (exceptId && menu.dataset.dropdownMenu === exceptId) return
      menu.classList.add("hidden")
    })
    if (exceptId !== "user-menu" && this.hasUserCaretTarget) {
      this.userCaretTarget.classList.toggle("rotate-180", false)
    }
  }

  // --- Collapsible sections ---

  toggleSection(event) {
    const button = event.currentTarget
    const children = button.nextElementSibling
    const chevron = button.querySelector('i')
    if (children) children.classList.toggle('hidden')
    if (chevron) chevron.classList.toggle('rotate-180')
  }

  // --- Sidebar drawer ---

  openDrawer() {
    if (!this.hasDrawerTarget) return
    this.drawerBackdropTarget.classList.remove("hidden")
    // Trigger reflow then animate
    requestAnimationFrame(() => {
      this.drawerTarget.classList.remove("-translate-x-full")
      this.drawerTarget.classList.add("translate-x-0")
    })
    document.body.classList.add("overflow-hidden")
  }

  closeDrawer() {
    if (!this.hasDrawerTarget) return
    this.drawerTarget.classList.remove("translate-x-0")
    this.drawerTarget.classList.add("-translate-x-full")
    this.drawerBackdropTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }
}
